module.exports = __webpack_public_path__ + "img/avatar.180ed5f4.png";